import { useCallback, useEffect, useMemo, useState } from "react";
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import { getStatus } from "@/store/slices/helpers/helpers";
import { clearData, fetchData } from "@/store/slices/fetch-slice";
import { apiKeys, apiMethods, apiUrls } from "@/store/api/constants";

export default function useOnActions() {
  const [isAlertDialog, setIsAlertDialog] = useState(false);

  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const state = useSelector((store) => store);
  const [currentRowId, setCurrentRowId] = useState(null);


  const deletePrimaryCustomerMasterStatus = 
  getStatus(state, apiKeys.deletePrimaryCustomerMaster, '');

  const onCloseAlert = useCallback(() => {
    setIsAlertDialog((prevState) => !prevState);
    setCurrentRowId(null);
  }, []);

  const onAgreeAlert = useCallback(() => {
    dispatch(fetchData({
      url: apiUrls.deletePrimaryCustomerMaster(currentRowId),
      method: apiMethods.DELETE,
      key: apiKeys.deletePrimaryCustomerMaster,
      successMsg: formatMessage({ id: "primarycustomer-master-has-been-deleted-successfully" }),
      failureMsg: formatMessage({ id: "failed-to-delete-primarycustomer-master" }),
    }))
    onCloseAlert();
  }, [dispatch, formatMessage, onCloseAlert, currentRowId]);


  const onRowDelete = useCallback((id) => {
    setCurrentRowId(id);
    setIsAlertDialog(true);
  }, []);


  useEffect(() => () => {
    dispatch(clearData({ key: apiKeys.deletePrimaryCustomerMaster }));
  }, [dispatch]);


  return useMemo(() => ({
    onRowDelete,
    deletePrimaryCustomerMasterStatus,
    isAlertDialog,
    onCloseAlert,
    onAgreeAlert,

  }), [
    onRowDelete,
    deletePrimaryCustomerMasterStatus,
    isAlertDialog,
    onCloseAlert,
    onAgreeAlert,
  ])
}
